// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"MailProperties_placeholder__2f_tN","placeholderselect":"MailProperties_placeholderselect__2jqZC","mailbody":"MailProperties_mailbody__ZfvaW"};